document.addEventListener('DOMContentLoaded', () => {
  const managedVideos = [...document.querySelectorAll('video[autoplay]')];
  managedVideos.forEach((video) => {
    video.classList.add('denta-video-managed');
    if (video.hasAttribute('data-smooth-video') || video.hasAttribute('data-gateway-video')) {
      video.preload = 'auto';
      const revealVideo = () => video.classList.add('is-ready');
      if (video.readyState >= 3) revealVideo();
      video.addEventListener('canplay', revealVideo, { once: true });
      video.addEventListener('playing', revealVideo, { once: true });
    }
  });
  const loadVideo = (video) => {
    if (video.dataset.loaded === 'true') return;
    let sourceChanged = false;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      sourceChanged = true;
    });
    video.dataset.loaded = 'true';
    if (sourceChanged) video.load();
  };

  const playVideo = (video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    loadVideo(video);
    const attempt = video.play();
    if (attempt?.catch) {
      attempt.catch(() => {
        video.addEventListener('canplay', () => video.play().catch(() => {}), { once: true });
      });
    }
  };

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.autoplay) playVideo(video);
        } else if (video.autoplay && video.dataset.loaded === 'true') {
          video.pause();
        }
      });
    }, { rootMargin: '700px 0px', threshold: 0.01 });
    managedVideos.forEach((video) => videoObserver.observe(video));
  } else {
    managedVideos.forEach((video) => {
      if (video.autoplay) playVideo(video);
    });
  }

  const retryVisibleGatewayVideos = () => {
    document.querySelectorAll('video[data-gateway-video]').forEach((video) => {
      const revealVideo = () => video.classList.add('is-ready');
      if (video.readyState >= 3) revealVideo();
      else video.addEventListener('canplay', revealVideo, { once: true });
      if (video.getClientRects().length && !video.ended) playVideo(video);
    });
  };
  retryVisibleGatewayVideos();
  window.addEventListener('pageshow', retryVisibleGatewayVideos);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) retryVisibleGatewayVideos();
  });
  ['touchstart', 'pointerdown'].forEach((eventName) => {
    document.addEventListener(eventName, retryVisibleGatewayVideos, { once: true, passive: true });
  });

  document.querySelectorAll('[data-reviews-link]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const reviews = document.querySelector('#denta-product-reviews');
      if (!reviews) return;
      event.preventDefault();
      reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-reviews-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const section = button.closest('.denta-product-reviews');
      const extraReviews = [...(section?.querySelectorAll('[data-review-card][hidden]') || [])];
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        const initialCount = Number(section?.dataset.initialReviews || 5);
        [...section.querySelectorAll('[data-review-card]')].forEach((card, index) => { card.hidden = index >= initialCount; });
        button.textContent = `${button.dataset.showLabel} (${section.querySelectorAll('[data-review-card]').length})`;
      } else {
        extraReviews.forEach((card) => { card.hidden = false; });
        button.textContent = button.dataset.hideLabel;
      }
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-carousel-track]');
    const slides = [...gallery.querySelectorAll('.os-product__slide')];
    const dots = [...gallery.querySelectorAll('[data-carousel-dot]')];
    if (!track || slides.length < 2) return;

    const setActiveSlide = (index, scroll = false) => {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === safeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (scroll) track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => setActiveSlide(Number(dot.dataset.carouselDot), true));
    });

    let frame;
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setActiveSlide(index);
      });
    }, { passive: true });

    gallery.showMedia = (mediaId) => {
      const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index >= 0) setActiveSlide(index, true);
    };
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('.os-product-form');
    const variantSelect = form?.querySelector('[data-variant-select]');
    const groups = [...(form?.querySelectorAll('[data-option-group]') || [])];
    if (!form || !variantSelect) return;

    const updateVariant = (variantOption) => {
      if (!variantOption) return;
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const saving = section.querySelector('[data-product-saving]');
      const stock = section.querySelector('[data-product-stock]');
      const button = section.querySelector('[data-add-to-cart]');
      const gallery = section.querySelector('[data-product-gallery]');
      const available = variantOption.dataset.available === 'true';

      variantSelect.value = variantOption.value;
      if (price) price.textContent = variantOption.dataset.price || '';
      if (compare) {
        compare.textContent = variantOption.dataset.comparePrice || '';
        compare.hidden = !variantOption.dataset.comparePrice;
      }
      if (saving) {
        saving.textContent = variantOption.dataset.saving || '';
        saving.hidden = !variantOption.dataset.saving;
      }
      if (stock) {
        stock.textContent = available ? stock.dataset.availableText : stock.dataset.unavailableText;
        stock.classList.toggle('is-unavailable', !available);
      }
      if (button) {
        button.disabled = !available;
        const availableLabel = button.dataset.priceLabel && variantOption.dataset.price
          ? `${button.dataset.priceLabel} — ${variantOption.dataset.price}`
          : button.dataset.availableLabel;
        button.textContent = available ? availableLabel : button.dataset.soldOutLabel;
      }
      const stickyPrice = section.querySelector('[data-sticky-price]');
      const stickyCompare = section.querySelector('[data-sticky-compare]');
      const stickyVariant = section.querySelector('[data-sticky-variant]');
      const stickyButton = section.querySelector('[data-sticky-buy] button');
      if (stickyPrice) stickyPrice.textContent = variantOption.dataset.price || '';
      if (stickyCompare) {
        stickyCompare.textContent = variantOption.dataset.comparePrice || '';
        stickyCompare.hidden = !variantOption.dataset.comparePrice;
      }
      if (stickyVariant) stickyVariant.value = variantOption.value;
      if (stickyButton) stickyButton.disabled = !available;
      if (variantOption.dataset.mediaId && gallery?.showMedia) gallery.showMedia(variantOption.dataset.mediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantOption.value);
      window.history.replaceState({}, '', url);
    };

    groups.forEach((group) => {
      group.addEventListener('change', () => {
        const selected = group.querySelector('input:checked');
        const label = group.querySelector('[data-selected-option]');
        if (label && selected) label.textContent = selected.value;

        const selectedValues = groups.map((item) => item.querySelector('input:checked')?.value);
        const match = [...variantSelect.options].find((option) => {
          try {
            return JSON.parse(option.dataset.options || '[]').every((value, index) => value === selectedValues[index]);
          } catch {
            return false;
          }
        });
        updateVariant(match);
      });
    });
  });

  document.querySelectorAll('[data-countdown]').forEach((countdown) => {
    const deadline = new Date(countdown.dataset.countdown).getTime();
    if (!Number.isFinite(deadline)) return;
    const hours = countdown.querySelector('[data-countdown-hours]');
    const minutes = countdown.querySelector('[data-countdown-minutes]');
    const seconds = countdown.querySelector('[data-countdown-seconds]');
    const updateCountdown = () => {
      const remaining = Math.max(0, deadline - Date.now());
      if (hours) hours.textContent = String(Math.floor(remaining / 3600000)).padStart(2, '0');
      if (minutes) minutes.textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
      if (seconds) seconds.textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
      if (remaining === 0) countdown.hidden = true;
    };
    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  });

  const stickyBuy = document.querySelector('[data-sticky-buy]');
  const stickyTrigger = document.querySelector('[data-add-to-cart]');
  if (stickyBuy && stickyTrigger) {
    let stickyFrame;
    const updateStickyBuy = () => {
      const triggerBounds = stickyTrigger.getBoundingClientRect();
      const shouldShow = triggerBounds.bottom <= 0;
      stickyBuy.classList.toggle('is-visible', shouldShow);
    };
    const requestStickyUpdate = () => {
      window.cancelAnimationFrame(stickyFrame);
      stickyFrame = window.requestAnimationFrame(updateStickyBuy);
    };
    updateStickyBuy();
    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
  }
});
